var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    {
      staticClass: "content-header",
      class: { "content-header--bordered": _vm.bordered },
    },
    [
      _vm._t("custom-back"),
      _vm._v(" "),
      _vm.backLink
        ? _c("router-link", {
            staticClass: "content-header__breadcrumb",
            attrs: { to: _vm.backLink },
            domProps: {
              textContent: _vm._s(
                _vm.backLinkTitle ? _vm.backLinkTitle : "back"
              ),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-header__inner" }, [
        _c("div", { staticClass: "content-header__title" }, [
          _c(
            "span",
            { staticClass: "h1" },
            [_vm._v(_vm._s(_vm.title)), _vm._t("title-extra")],
            2
          ),
          _vm._v(" "),
          _vm.subTitle
            ? _c("p", { domProps: { textContent: _vm._s(_vm.subTitle) } })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-header__actions" },
          [_vm._t("actions")],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-header__extra" }, [_vm._t("extra")], 2),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }